import React from 'react';
import BrowserFrame from './BrowserFrame';
import { Search, Filter, MapPin } from 'lucide-react';

const TEAL = '#02857E';

const rows = [
  { origin: 'Dallas, TX', dest: 'Atlanta, GA', eq: 'Van', mi: 781, rate: '$2,150', rpm: '2.75' },
  { origin: 'Chicago, IL', dest: 'Newark, NJ', eq: 'Reefer', mi: 812, rate: '$2,480', rpm: '3.05' },
  { origin: 'Los Angeles, CA', dest: 'Phoenix, AZ', eq: 'Flatbed', mi: 372, rate: '$1,290', rpm: '3.47' },
  { origin: 'Houston, TX', dest: 'Denver, CO', eq: 'Van', mi: 1027, rate: '$2,890', rpm: '2.81' },
  { origin: 'Seattle, WA', dest: 'Boise, ID', eq: 'Reefer', mi: 502, rate: '$1,720', rpm: '3.43' },
];

const LoadBoardMockup: React.FC<{ className?: string }> = ({ className }) => (
  <BrowserFrame url="app.lanerunner.com/search-loads" className={className}>
    <div className="p-4 sm:p-5">
      {/* filter bar */}
      <div className="flex items-center gap-2 mb-4">
        <div className="flex-1 flex items-center gap-2 px-3 py-2 rounded-lg bg-white border border-gray-200">
          <Search className="h-3.5 w-3.5 text-gray-400" />
          <span className="text-xs text-gray-500">Dallas, TX → Atlanta, GA</span>
        </div>
        <span className="px-2.5 py-1.5 rounded-md text-[11px] font-medium bg-gray-100 text-gray-700 border border-gray-200 inline-flex items-center gap-1">
          <Filter className="h-3 w-3" /> Van
        </span>
        <span
          className="px-2.5 py-1.5 rounded-md text-[11px] font-semibold text-white"
          style={{ backgroundColor: TEAL }}
        >
          Search
        </span>
      </div>

      {/* table */}
      <div className="rounded-lg border border-gray-200 overflow-hidden bg-white">
        <div className="grid grid-cols-12 gap-2 px-3 py-2 bg-gray-50 border-b border-gray-200 text-[10px] font-semibold text-gray-500 uppercase tracking-wider">
          <div className="col-span-5">Lane</div>
          <div className="col-span-2">Equip</div>
          <div className="col-span-1 text-right">Mi</div>
          <div className="col-span-2 text-right">Rate</div>
          <div className="col-span-2 text-right">RPM</div>
        </div>
        {rows.map((r, i) => (
          <div
            key={i}
            className={`grid grid-cols-12 gap-2 px-3 py-2.5 text-xs items-center ${
              i % 2 ? 'bg-gray-50/50' : ''
            } border-b border-gray-100 last:border-0`}
          >
            <div className="col-span-5 flex items-center gap-1.5 min-w-0">
              <MapPin className="h-3 w-3 flex-shrink-0" style={{ color: TEAL }} />
              <span className="font-medium text-gray-900 truncate">{r.origin}</span>
              <span className="text-gray-400">→</span>
              <span className="font-medium text-gray-900 truncate">{r.dest}</span>
            </div>
            <div className="col-span-2">
              <span className="px-1.5 py-0.5 rounded text-[10px] font-medium bg-gray-100 text-gray-700">
                {r.eq}
              </span>
            </div>
            <div className="col-span-1 text-right text-gray-600">{r.mi}</div>
            <div className="col-span-2 text-right font-bold text-gray-900">{r.rate}</div>
            <div className="col-span-2 text-right" style={{ color: TEAL }}>
              <span className="font-semibold">${r.rpm}</span>
            </div>
          </div>
        ))}
      </div>

      <div className="mt-3 flex items-center justify-between text-[11px] text-gray-500">
        <span>5 of 142 loads</span>
        <span className="inline-flex items-center gap-1">
          <span className="h-1.5 w-1.5 rounded-full bg-green-500 animate-pulse" />
          Live board
        </span>
      </div>
    </div>
  </BrowserFrame>
);

export default LoadBoardMockup;
